// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  StatsTable,AnimatedView,ScoreCard,StatsGraph, GameTypeTab
}                         from '../../../../components';
import {Link} from 'react-router-dom';
var Spinner = require('react-spinkit');
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import styles             from './style'
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

class BuddyAllocation extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
    })
  };
   constructor(props){
      super(props);
      this.state        = { venue_id: this.props.venue ? this.props.venue : '',
                            allocationdata: '',
                            val: '',
                            game_types: [],
                            game_type_id: 2,
                            result:{
                              id: '',
                              Available: '',
                            }
                          } ;
      this.handlePicker = this.handlePicker.bind(this);    
      this.handleVenue = this.handleVenue.bind(this);  
      this.handleChange = this.handleChange.bind(this);  
                                        
  }

  componentWillMount() {
    this.getFixtureList();
    // const { actions: { enterPage } } = this.props;
    // enterPage('Customers');
  }

  componentDidMount() {
    this.getAllocationdata();
  }

  componentWillUnmount() {
    // const { actions: { leavePage } } = this.props;
    // leavePage('Customers');
  }
  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ game_types: data.game_type, venues: data.venues},()=>{
        if(!this.props.venue){
          this.setState({venue_id:data.venues[0].id})
        }}))
       .catch(error => error);
  }

  componentWillReceiveProps(newProps){}

  getAllocationdata(){
    const url = `${getLocationOrigin()}/trainer/get_buddy_allocation/?game_type_id=${this.state.game_type_id}&venue_id=${this.state.venue_id}`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ allocationdata: data.results, }))
       .catch(error => error);
  }
  postBuddyallocation(props){
    console.log(props);
    const url = `${getLocationOrigin()}/fixture/allocate_buddy_to_fixture/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'fixture_id': this.state.result.id,
                                        'buddies': this.state.result.Available});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(response =>
        {
          alert(response.Message);
          this.getAllocationdata();
        }
      )
      .catch(error => {
        console.log(error);
        alert(error.Message);
      });
  }
  deleteBuddyallocation(props){
    console.log(props);
    const url = `${getLocationOrigin()}/fixture/remove_buddy_from_fixture/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'fixture_id': this.state.result.id,
                                        'buddies': this.state.result.Available});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(response =>
        {
          alert(response.Message);
          this.getAllocationdata();
        }
      )
      .catch(error => {
        console.log(error);
        alert(error.Message);
      });
  }
  
  handleChange(event) {
      var new_selected_one = Object.assign({}, this.state.result);
      new_selected_one.Available = event.target.value
      new_selected_one.id = event.target.id
      this.setState({result: new_selected_one},()=>{this.postBuddyallocation(this.props)});
  }

  onDelete(id, item) {
      var new_selected_one = Object.assign({}, this.state.result);
      new_selected_one.Available = item
      new_selected_one.id = id
      this.setState({result: new_selected_one},()=>{this.deleteBuddyallocation(this.props)});
  }
  handlePicker(event){
    console.log(event.target.value);
    this.setState({game_type_id: event.target.value}, ()=>{this.getAllocationdata();});
  }
  handleVenue(event){
    console.log(event.target.value);
    this.setState({venue_id: event.target.value}, ()=>{this.getAllocationdata();});
  }

  render() {
    console.log('this.state.allocationdata')
    console.log('venue',this.state.venue)
    console.log('popr',this.props)
    console.log(this.state.allocationdata)
    const {
      statsTable,scoreCard,statsGraph,
    } = this.props;
         
    return(
      <AnimatedView>
        <div>
           <div className="col-md-12" style={styles.container}>
                            <div className="row" style={styles.table}>
                              <div style={styles.main_header} className="col-md-12">
                                <h5 style={{textAlign:'center', color: '#333333', }}>Buddy Allocation</h5>
                              </div>
                              <div className="row" style={{padding: '1%'}}>
                              {
                                this.state.game_types ?
                                <select name="game_types" style={{padding: '4px', border: '3px solid #a1d9eb', background: '#a1d9eb',color: '#333333'}} className="col-md-3 pull-right" value={this.state.game_type_id} onChange={this.handlePicker}>
                                  {
                                    this.state.game_types.map((x, index) => (
                                    <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                                    ))
                                  }
                                </select>
                                :
                                <div></div>
                              }
                              </div>
                              <div className="row" style={{padding: '1%'}}>
                              {
                                this.state.venues ?
                                <select name="venues" style={{padding: '4px', border: '3px solid #a1d9eb', background: '#a1d9eb',color: '#333333'}} 
                                className="col-md-3 pull-right" value={this.state.venue_id} onChange={this.handleVenue} disabled={this.props.venue ? 'disabled': ''}> 
                                  {
                                    this.state.venues.map((x, index) => (
                                    <option key={x.id} value={x.id}>{x.name}</option>
                                    ))
                                  }
                                </select>
                                :
                                <div></div>
                              }
                              </div>

                              <div style={styles.items}>
                                <div className="col-md-12" style={{width:'100%'}}>
                                {this.state.allocationdata ?
                                   <div style={{display: 'table', margin: 'auto'}}>
                                    <div style={styles.resp_table_caption}>
                                      <div style={styles.resp_table_header}>
                                        <div className="col-md-1" style={styles.resp_table_cells}>Venue/Game</div>
                                        <div className="col-md-1" style={styles.resp_table_cells}>Time</div>
                                        <div className="col-md-1" style={styles.resp_table_cells}> Monday</div>
                                        <div className="col-md-1" style={styles.resp_table_cells}>Tuesday</div>
                                        <div className="col-md-1" style={styles.resp_table_cells}>Wednesday</div>
                                        <div className="col-md-1" style={styles.resp_table_cells}>Thursday</div>
                                        <div className="col-md-1" style={styles.resp_table_cells}>Friday</div>
                                        <div className="col-md-1" style={styles.resp_table_cells}>Saturday</div>
                                        <div className="col-md-1" style={styles.resp_table_cells}>Sunday</div>
                                      </div>
                                    </div>
                                    <div style={styles.resp_table_body}>
                                    {
                                      this.state.allocationdata.map((item, index)=>{
                                        return <div className={"allocation_contents" + (index%2 == 0 ? 'even' : 'odd')} key={index} style={styles.resp_table_row}>
                                        <div className="col-md-1" style={styles.resp_table_cell}>{item.venue}-{item.game_type}</div>
                                        <div className="col-md-1" style={styles.resp_table_cell_time}>{item.start_time}-{item.end_time}</div>
                                        {
                                          (item.Monday == null) ?
                                          <div className="col-md-2" style={styles.resp_table_cell_days}>
                                              <span style={{textAlign: 'left',fontWeight: 'bold',}}>No Fixture</span>
                                          </div>
                                            :
                                           <div className="col-md-2" style={styles.resp_table_cell_days}>
                                            {
                                              (item.Monday.buddies.length <= 0) ?
                                              <div>
                                                <span style={styles.titles}>AVAILABLE</span>
                                                { (item.buddy_for_game <= 0) ?
                                                  <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                  :
                                                <select className="available"  style={styles.row_content} id={item.Monday.fixture_id} onChange={this.handleChange}>
                                                <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (

                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                                </select>
                                              }
                                            </div>
                                            :
                                            <div>
                                              { 
                                                item.Monday.buddies.map((y, index)=>(
                                                  <div key={index} style={styles.row_content}>
                                                   <span style={styles.content}>{y}</span>
                                                   <i onClick={()=>{this.onDelete(item.Monday.fixture_id, y)}} className="fas fa-trash" style={{color: '#D26860', float: 'right'}}></i>
                                                   </div>
                                                  ))
                                              }
                                              
                                              <span style={styles.titles}>AVAILABLE</span>
                                                { (item.buddy_for_game <= 0) ?
                                                  <span style={{textAlign: 'left',fontWeight: 'bold', color: '#000000',}}>No coaches to allocate</span>
                                                  :
                                                <select className="available" style={styles.row_content} id={item.Monday.fixture_id} onChange={this.handleChange}>
                                                    <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (

                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                                </select>
                                              }
                                            </div>
                                            }
                                         
                                          </div>
                                          }
                                          {
                                          (item.Tuesday == null) ?
                                          <div className="col-md-2" style={styles.resp_table_cell_days}>
                                              <span style={{textAlign: 'left',fontWeight: 'bold',}}>No Fixture</span>
                                          </div>
                                            :
                                           <div className="col-md-2" style={styles.resp_table_cell_days}>
                                            {
                                              (item.Tuesday.buddies.length <= 0) ?
                                              <div>
                                              <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Tuesday.fixture_id} onChange={this.handleChange}>
                                                    <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            :
                                            <div>
                                            { 
                                              item.Tuesday.buddies.map((y, index)=>(
                                                <div key={index} style={styles.row_content}>
                                                 <span style={styles.content}>{y}</span>
                                                 <i onClick={()=>{this.onDelete(item.Tuesday.fixture_id, y)}} className="fas fa-trash" style={{color: '#D26860', float: 'right'}}></i>
                                                 </div>
                                                ))
                                            }
                                            
                                            <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Tuesday.fixture_id} onChange={this.handleChange}>
                                                   <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            }
                                         
                                            </div>
                                          }
                                         {
                                          (item.Wednesday == null) ?
                                          <div className="col-md-2" style={styles.resp_table_cell_days}>
                                              <span style={{textAlign: 'left',fontWeight: 'bold',}}>No Fixture</span>
                                          </div>
                                            :
                                           <div className="col-md-2" style={styles.resp_table_cell_days}>
                                            {
                                              (item.Wednesday.buddies.length <= 0) ?
                                              <div>
                                              <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Wednesday.fixture_id} onChange={this.handleChange}>
                                                    <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            :
                                            <div>
                                            
                                            { 
                                              item.Wednesday.buddies.map((y, index)=>(
                                                <div key={index} style={styles.row_content}>
                                                 <span style={styles.content}>{y}</span>
                                                 <i onClick={()=>{this.onDelete(item.Wednesday.fixture_id, y)}} className="fas fa-trash" style={{color: '#D26860', float: 'right'}}></i>
                                                 </div>
                                                ))
                                            }
                                            
                                            <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Wednesday.fixture_id} onChange={this.handleChange}>
                                                <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            }
                                         
                                            </div>
                                          }
                                        {
                                          (item.Thursday == null) ?
                                          <div className="col-md-2" style={styles.resp_table_cell_days}>
                                              <span style={{textAlign: 'left',fontWeight: 'bold',}}>No Fixture</span>
                                          </div>
                                            :
                                           <div className="col-md-2" style={styles.resp_table_cell_days}>
                                            {
                                              (item.Thursday.buddies.length <= 0) ?
                                              <div>
                                              <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Thursday.fixture_id} onChange={this.handleChange}>
                                                  <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            :
                                            <div>
                                            
                                            { 
                                              item.Thursday.buddies.map((y, index)=>(
                                                <div key={index} style={styles.row_content}>
                                                 <span style={styles.content}>{y}</span>
                                                 <i onClick={()=>{this.onDelete(item.Thursday.fixture_id, y)}} className="fas fa-trash" style={{color: '#D26860', float: 'right'}}></i>
                                                 </div>
                                                ))
                                            }
                                            
                                            <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Thursday.fixture_id} onChange={this.handleChange}>
                                                 <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            }
                                         
                                            </div>
                                          }
                                         {
                                          (item.Friday == null) ?
                                          <div className="col-md-2" style={styles.resp_table_cell_days}>
                                              <span style={{textAlign: 'left',fontWeight: 'bold',}}>No Fixture</span>
                                          </div>
                                            :
                                           <div className="col-md-2" style={styles.resp_table_cell_days}>
                                            {
                                              (item.Friday.buddies.length <= 0) ?
                                              <div >
                                              <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Friday.fixture_id} onChange={this.handleChange}>
                                                  <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            :
                                            <div >
                                            
                                            { 
                                              item.Friday.buddies.map((y, index)=>(
                                                <div key={index} style={styles.row_content}>
                                                 <span style={styles.content}>{y}</span>
                                                 <i onClick={()=>{this.onDelete(item.Friday.fixture_id, y)}} className="fas fa-trash" style={{color: '#D26860', float: 'right'}}></i>
                                                 </div>
                                                ))
                                            }
                                            
                                            <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Friday.fixture_id} onChange={this.handleChange}>
                                                  <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            }
                                         
                                            </div>
                                          }
                                         {
                                          (item.Saturday == null) ?
                                          <div className="col-md-2" style={styles.resp_table_cell_days}>
                                              <span style={{textAlign: 'left',fontWeight: 'bold',}}>No Fixture</span>
                                          </div>
                                            :
                                           <div className="col-md-2" style={styles.resp_table_cell_days}>
                                            {
                                              (item.Saturday.buddies.length <= 0) ?
                                              <div>
                                              <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Saturday.fixture_id} onChange={this.handleChange}>
                                                   <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            :
                                            <div>
                                            
                                            { 
                                              item.Saturday.buddies.map((y, index)=>(
                                                <div key={index} style={styles.row_content}>
                                                 <span style={styles.content}>{y}</span>
                                                 <i onClick={()=>{this.onDelete(item.Saturday.fixture_id, y)}} className="fas fa-trash" style={{color: '#D26860', float: 'right'}}></i>
                                                 </div>
                                                ))
                                            }
                                            
                                            <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Saturday.fixture_id} onChange={this.handleChange}>
                                                  <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            }
                                         
                                            </div>
                                          }
                                      {
                                          (item.Sunday == null) ?
                                          <div className="col-md-2" style={styles.resp_table_cell_days}>
                                              <span style={{textAlign: 'left',fontWeight: 'bold',}}>No Fixture</span>
                                          </div>
                                            :
                                           <div className="col-md-2" style={styles.resp_table_cell_days}>
                                            {
                                              (item.Sunday.buddies.length <= 0) ?
                                              <div>
                                              <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Sunday.fixture_id} onChange={this.handleChange}>
                                                  <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            :
                                            <div>
                                            
                                            { 
                                              item.Sunday.buddies.map((y, index)=>(
                                                <div key={index} style={styles.row_content}>
                                                 <span style={styles.content}>{y}</span>
                                                 <i onClick={()=>{this.onDelete(item.Sunday.fixture_id, y)}} className="fas fa-trash" style={{color: '#D26860', float: 'right'}}></i>
                                                 </div>
                                                ))
                                            }
                                            
                                            <span style={styles.titles}>AVAILABLE</span>
                                              { (item.buddy_for_game <= 0) ?
                                                <span style={{textAlign: 'left',color: '#000000'}}>No coaches to allocate</span>
                                                :
                                              <select className="available" style={styles.row_content} id={item.Sunday.fixture_id} onChange={this.handleChange}>
                                                  <option value="" selected disabled hidden>Choose here</option>
                                                    {
                                                      item.buddy_for_game.map((x, index) => (
                                                      <option key={index} value={x}>{x}</option>
                                                      ))
                                                    }
                                              </select>
                                            }
                                            </div>
                                            }
                                         
                                            </div>
                                          }
                                      </div>
                                      })
                                    }
                                    </div>
                                  </div>
                                  :
                                  <div><Spinner name="ball-grid-pulse" color="darkturquoise"/></div>
                                }
                                </div>
                              </div>  
                            </div>  
                          </div>            
      </div>
      </AnimatedView>
    );
  }
}

export default BuddyAllocation;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/buddyAllocation/index.js